export default __webpack_public_path__ + "static/media/elasticbox.f9a7abf2.svg";